module.exports = __webpack_public_path__ + "img/appTableNoData.e621f9a.webp";